import React from 'react';

export const CalendarGrid = ({ 
  currentMonth, 
  currentYear, 
  workdays, 
  holidays, 
  onDayClick,
  isEditing
}) => {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const daysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();
  const firstDayOfMonth = (month, year) => new Date(year, month, 1).getDay();

  const generateCalendarDays = () => {
    const days = [];
    const totalDays = daysInMonth(currentMonth, currentYear);
    const startDay = firstDayOfMonth(currentMonth, currentYear);

    for (let i = 0; i < startDay; i++) {
      days.push(<div key={`empty-${i}`} className="h-16 bg-gray-100"></div>);
    }

    for (let day = 1; day <= totalDays; day++) {
      const year = currentYear;
      const month = String(currentMonth + 1).padStart(2, '0');
      const dayPadded = String(day).padStart(2, '0');
      const dateString = `${year}-${month}-${dayPadded}`;
      const date = new Date(year, currentMonth, day);
      const dayOfWeek = date.getDay();
      
      const isWorkday = workdays.includes(dayOfWeek === 0 ? 7 : dayOfWeek);
      const isWeekend = !isWorkday;
      const holiday = holidays.find(h => h.date === dateString);
      const isHoliday = !!holiday;
      
      let bgColorClass = isHoliday ? 'bg-red-200 hover:bg-red-300' :
        isWeekend ? 'bg-blue-200 hover:bg-blue-300' : 'bg-white hover:bg-gray-100';

      days.push(
        <div 
          key={day} 
          className={`h-16 border border-gray-200 p-1 cursor-pointer transition-colors ${bgColorClass} ${
            isEditing ? 'cursor-pointer' : 'cursor-default'
          }`}
          onClick={() => isEditing && onDayClick(dateString)}
        >
          <div className="flex justify-between">
            <span className="font-semibold">{day}</span>
            {isHoliday && <span className="text-xs bg-red-500 text-white px-1 rounded">Holiday</span>}
          </div>
          {isHoliday && (
            <div className="text-xs text-red-800 mt-1 truncate">
              {holiday.name}
            </div>
          )}
        </div>
      );
    }

    return days;
  };

  return (
    <div className="bg-white rounded-lg shadow-lg mb-6">
      <div className="mb-4 flex justify-between items-center p-4">
        <div className="flex space-x-2">
          <h2 className="text-xl font-bold">
            {months[currentMonth]} {currentYear}
          </h2>
        </div>
        
        <div className="flex items-center space-x-4 text-sm">
          <div className="flex items-center">
            <div className="w-4 h-4 bg-blue-200 mr-2"></div>
            <span>Weekend</span>
          </div>
          <div className="flex items-center">
            <div className="w-4 h-4 bg-red-200 mr-2"></div>
            <span>Holiday</span>
          </div>
          <div className="flex items-center">
            <div className="w-4 h-4 bg-white border border-gray-200 mr-2"></div>
            <span>Work Day</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-7 gap-px bg-gray-200 border border-gray-300 rounded-lg overflow-hidden">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
          <div key={day} className="bg-gray-700 text-white text-center py-2 font-medium">
            {day}
          </div>
        ))}
        {generateCalendarDays()}
      </div>
    </div>
  );
};